import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { CustomerBooking, LoginPage } from "./pages";
import { AdminPanel, AdminRecurrencies } from "./components/admin";
import {
  AdminDashboard,
  AdminCaixaDoDiaPage,
  AdminCaixaDoMesPage,
  AdminProjecoesPage,
  AdminClientBirthdaysPage,
  AdminFollowUpClientsPage,
  AdminPendingPaymentsPage,
  AdminWeekAppointmentRemindersPage,
  AdminCarsCompletedThroughputPage,
  AdminCarsCompletedThroughputPeriodPage,
  AdminEmployeeProgressPage,
  AdminAppointments,
  AdminAppointmentsMonthCalendar,
  AdminServices,
  AdminProfessionals,
  AdminSettings,
  AdminClients,
  AdminClientCars,
  AdminBudgets,
} from "./components/admin";
import { AdminExpenses } from "./components/admin/AdminExpenses";
import { ProfessionalAvailabilityPage } from "./components/admin/AdminProfessionals/ProfessionalAvailabilityPage";
import { AppointmentDetails } from "./components/admin/AdminAppointments/AppointmentDetails";
import { ClientDetails } from "./components/admin/AdminClients/ClientDetails";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { PublicRoute } from "./components/PublicRoute";
import { ToasterProvider } from "./components/shared";
import { CompanyProvider } from "./contexts/CompanyContext";
import { authService } from "./services";
import "./App.css";

function App() {
  return (
    <ToasterProvider>
      <CompanyProvider>
        <Router>
          <Routes>
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <LoginPage />
                </PublicRoute>
              }
            />
            <Route path="/client" element={<CustomerBooking />} />
            <Route path="/client/appointments" element={<CustomerBooking />} />
            <Route path="/cliente" element={<Navigate to="/client" replace />} />
            <Route
              path="/cliente/agendamentos"
              element={<Navigate to="/client/appointments" replace />}
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute allowedForProfessional={true}>
                  <AdminPanel />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminIndexRedirect />} />
              <Route
                path="dashboard"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="daily-cash"
                element={
                  <ProtectedRoute>
                    <AdminCaixaDoDiaPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="monthly-cash"
                element={
                  <ProtectedRoute>
                    <AdminCaixaDoMesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="projections"
                element={
                  <ProtectedRoute>
                    <AdminProjecoesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="birthdays"
                element={
                  <ProtectedRoute>
                    <AdminClientBirthdaysPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="follow-up-clients"
                element={
                  <ProtectedRoute>
                    <AdminFollowUpClientsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="pending-payments"
                element={
                  <ProtectedRoute>
                    <AdminPendingPaymentsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="week-reminders"
                element={
                  <ProtectedRoute>
                    <AdminWeekAppointmentRemindersPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="cars-throughput/period"
                element={
                  <ProtectedRoute>
                    <AdminCarsCompletedThroughputPeriodPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="cars-throughput"
                element={
                  <ProtectedRoute>
                    <AdminCarsCompletedThroughputPage />
                  </ProtectedRoute>
                }
              />
              <Route path="caixa-do-dia" element={<Navigate to="/admin/daily-cash" replace />} />
              <Route path="caixa-do-mes" element={<Navigate to="/admin/monthly-cash" replace />} />
              <Route path="meta-receita" element={<Navigate to="/admin/monthly-cash" replace />} />
              <Route path="revenue-target" element={<Navigate to="/admin/monthly-cash" replace />} />
              <Route path="projecoes" element={<Navigate to="/admin/projections" replace />} />
              <Route path="aniversarios" element={<Navigate to="/admin/birthdays" replace />} />
              <Route path="retorno-clientes" element={<Navigate to="/admin/follow-up-clients" replace />} />
              <Route path="pagamentos-pendentes" element={<Navigate to="/admin/pending-payments" replace />} />
              <Route path="lembretes-semana" element={<Navigate to="/admin/week-reminders" replace />} />
              <Route path="producao-veiculos" element={<Navigate to="/admin/cars-throughput" replace />} />
              <Route
                path="employee"
                element={
                  <ProtectedRoute>
                    <AdminEmployeeProgressPage />
                  </ProtectedRoute>
                }
              />
              <Route path="funcionario" element={<Navigate to="/admin/employee" replace />} />
              <Route
                path="appointments"
                element={
                  <ProtectedRoute allowedForProfessional={true}>
                    <AdminAppointments />
                  </ProtectedRoute>
                }
              />
              <Route
                path="appointments-calendar"
                element={
                  <ProtectedRoute>
                    <AdminAppointmentsMonthCalendar />
                  </ProtectedRoute>
                }
              />
              <Route
                path="appointments/:appointmentId"
                element={
                  <ProtectedRoute allowedForProfessional={true}>
                    <AppointmentDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="services"
                element={
                  <ProtectedRoute>
                    <AdminServices />
                  </ProtectedRoute>
                }
              />
              <Route
                path="professionals"
                element={
                  <ProtectedRoute>
                    <AdminProfessionals />
                  </ProtectedRoute>
                }
              />
              <Route
                path="professionals/:professionalId/availability"
                element={
                  <ProtectedRoute>
                    <ProfessionalAvailabilityPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="clients"
                element={
                  <ProtectedRoute>
                    <AdminClients />
                  </ProtectedRoute>
                }
              />
              <Route
                path="clients/:clientId"
                element={
                  <ProtectedRoute>
                    <ClientDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="clients/:clientId/cars"
                element={
                  <ProtectedRoute>
                    <AdminClientCars />
                  </ProtectedRoute>
                }
              />
              <Route
                path="budgets"
                element={
                  <ProtectedRoute>
                    <AdminBudgets />
                  </ProtectedRoute>
                }
              />
              <Route path="orcamentos" element={<Navigate to="/admin/budgets" replace />} />
              <Route
                path="expenses"
                element={
                  <ProtectedRoute>
                    <AdminExpenses />
                  </ProtectedRoute>
                }
              />
              <Route
                path="recurrencies"
                element={
                  <ProtectedRoute>
                    <AdminRecurrencies />
                  </ProtectedRoute>
                }
              />
              <Route
                path="settings"
                element={
                  <ProtectedRoute requireCompanyAdmin={true}>
                    <AdminSettings />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/"
              element={<RootRedirect />}
            />
            {/* Catch-all route for non-existent routes */}
            <Route
              path="*"
              element={<NotFoundRedirect />}
            />
          </Routes>
        </Router>
      </CompanyProvider>
    </ToasterProvider>
  );
}

// Redirect for /admin: professionals go to appointments, company users to Caixa do Dia
const AdminIndexRedirect: React.FC = () => {
  const userData = authService.getUserData();
  const isProfessional = userData?.userType === "professional";
  return (
    <Navigate
      to={isProfessional ? "/admin/appointments" : "/admin/daily-cash"}
      replace
    />
  );
};

// Component to handle root route redirects based on authentication status
const RootRedirect: React.FC = () => {
  const isAuthenticated = authService.isAuthenticated();

  if (isAuthenticated) {
    const userData = authService.getUserData();
    const isProfessional = userData?.userType === "professional";
    return (
      <Navigate
        to={isProfessional ? "/admin/appointments" : "/admin/daily-cash"}
        replace
      />
    );
  }
  return <Navigate to="/login" replace />;
};

// Component to handle 404 redirects based on authentication status
const NotFoundRedirect: React.FC = () => {
  const isAuthenticated = authService.isAuthenticated();

  if (isAuthenticated) {
    const userData = authService.getUserData();
    const isProfessional = userData?.userType === "professional";
    return (
      <Navigate
        to={isProfessional ? "/admin/appointments" : "/admin/daily-cash"}
        replace
      />
    );
  }
  return <Navigate to="/login" replace />;
};

export default App;
